module.exports = {
  // 'skillacademy/tags': () => {
  //   return {
  //     data: {
  //       tagSerial: 'tgs1',
  //     },
  //     status: 'success',
  //     message: 'success',
  //   };
  // },
};
